import Carousel from './carousel';

class ProductAccordionSlider extends Carousel {
  constructor(selector: HTMLElement | string) {

    const slideCount = selector instanceof HTMLElement ? selector.querySelectorAll('.swiper-slide').length : null;

    const SPEED = 800;

    super(selector, {
      effect: 'slide',
      grabCursor: true,
      speed: SPEED,
      slidesPerView: 1.25,
      spaceBetween: 30,
      loop: !slideCount || (window.innerWidth < 768 && slideCount && slideCount > 1) || (slideCount && slideCount > 3) ? true : false,
      autoplay: false,
      navigation: {
        nextEl: selector instanceof HTMLElement ? selector.closest('.o-accordion__content')?.querySelector('.swiper-button-next') : '.swiper-button-next',
        prevEl: selector instanceof HTMLElement ? selector.closest('.o-accordion__content')?.querySelector('.swiper-button-prev') : '.swiper-button-prev',
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        1260: {
          slidesPerView: 3,
          spaceBetween: 45,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  }

  init() {
    super.init();
  }
}

export default ProductAccordionSlider;
